import styles from "./TheTable.module.css";

const getColumnStyle = (column) => ({
  width: column.width,
  minWidth: column.minWidth,
  maxWidth: column.maxWidth,
  textAlign: column.align || "left",
});

const getCellClassName = (column) => {
  const classNames = [];

  if (column.truncate) classNames.push(styles.truncateText);
  if (column.wrap) classNames.push(styles.wrapText);

  return classNames.join(" ");
};

const TheTable = ({ columns = [], data = [], minWidth = "900px" }) => {
  const hasData = Array.isArray(data) && data.length > 0;

  if (!hasData) {
    return <p className={styles.emptyState}>No records found.</p>;
  }

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table} style={{ minWidth }}>
        <colgroup>
          {columns.map((column) => (
            <col key={column.key} style={getColumnStyle(column)} />
          ))}
        </colgroup>

        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key} style={getColumnStyle(column)}>
                {column.title}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.map((row, index) => (
            <tr key={row._id || row.id || index}>
              {columns.map((column) => {
                const value = column.render ? column.render(row) : row[column.key];

                return (
                  <td
                    key={column.key}
                    style={{
                      ...getColumnStyle(column),
                      "--line-count": column.lines || 1,
                    }}
                    className={getCellClassName(column)}
                    title={typeof value === "string" ? value : ""}
                  >
                    {value}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TheTable;